import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    QueryList,
    ViewChild,
    ViewChildren
} from '@angular/core'
import { NgForm, NgModel } from '@angular/forms'
import { BsModalRef } from 'ngx-bootstrap/modal'

import { Bandeira } from '../../../../pkw-data/collect/bandeira.model'
import { OperadoraDeMaquina } from '../../../../pkw-data/collect/operadora-de-maquina.model'
import { ConfigsBandeirasOperadora } from '../configuracao-integracao-bandeira.component'
import { ConfiguracaoIntegracaoBandeira } from '../../../shared/configuracao-integracao-bandeira'

declare const $

@Component({
    selector: 'col-configuracao-bandeira-modal',
    templateUrl: './configuracao-bandeira-modal-edicao.component.html',
    styles: ['.modal-body { padding-bottom: 0; }']
})
export class ConfiguracaoBandeiraModalEdicaoComponent implements OnInit {
    @Input() configuracao: ConfiguracaoIntegracaoBandeira
    @Input() operadoras: OperadoraDeMaquina[]
    @Input() bandeiras: Bandeira[]
    @Input() configuracoesExistentes: ConfigsBandeirasOperadora[]
    @ViewChild(NgForm) form: NgForm
    @ViewChildren('codigoDeChamada') codigosDeChamadaModels: QueryList<NgModel>

    errorMessages = ERROR_MESSAGES
    isEdicao: boolean
    salvo = new EventEmitter<ConfiguracaoIntegracaoBandeira>()

    constructor(private bsModalRef: BsModalRef) {}

    ngOnInit() {
        this.isEdicao = this.configuracao.bandeira ? true : false
    }

    salvar() {
        if (this.form.valid) {
            this.salvo.emit(this.configuracao)
        }
    }

    fechar() {
        this.bsModalRef.hide()
    }

    selecionarTab(event: MouseEvent) {
        const $a = $(event.target)
        $a.tab('show')
    }

    getCodigosDeChamadaControls() {
        return (
            this.codigosDeChamadaModels &&
            this.codigosDeChamadaModels.map(codigo => codigo.control)
        )
    }

    atualizarNomeDaOperadora() {
        if (this.configuracao.operadora) {
            this.configuracao.codigos.NomeDaOperadora = this.configuracao.operadora.nome
        }
    }

    atualizarBandeira() {
        if (this.configuracao.bandeira) {
            this.configuracao.codigos.Bandeira = this.configuracao.bandeira.descricao
        }
    }
}

const ERROR_MESSAGES = {
    required: 'Este campo é obrigatório.',
    configuracaoExistente: 'Essa bandeira já foi configurada para Operadora selecionada.',
    atLeastOne: 'Pelo menos um dos códigos deve ser preenchido.'
}



// WEBPACK FOOTER //
// ./src/app/configuracao/configuracao-integracao/configuracao-integracao-bandeira/configuracao-bandeira-modal-edicao/configuracao-bandeira-modal-edicao.component.ts